var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPlaceHolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65,
    r: 65,
    fill: "#E1E4EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 99C46.2 99 34 85.1238 34 68H40.1C40.1 83.0571 51.2833 92.8 64.5 92.8C77.7167 92.8 88.9 83.0571 88.9 68H95C95 85.1238 82.8 99 64.5 99Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceHolder);
export default __webpack_public_path__ + "static/media/UserPlaceHolder.71d82299a776082b27ebfb34d75afa86.svg";
export { ForwardRef as ReactComponent };